export default function PrivacyPolicy() {
  return (
    <div className="h-full justify-center items-center w-full px-7 md:px-14 lg:px-28 my-10 leading-5">
      <p className="text-center font-bold text-xl">Privacy policy</p>
      <p className="font-semibold">INTRODUCTION</p>
      <br />
      <p>
        In this Privacy Policy references to we, us or ProjectChef means BRAINIT
        CONSULTING LTD, a limited liability company based in UK, with our
        headquarters located at&nbsp;
      </p>
      <br />
      <p>71-75, Shelton Street</p>
      <p>London</p>
      <p>WC2H 9JQ</p>
      <p>United Kingdom</p>
      <br />
      <p>
        References to you or your means the person accessing and using the
        ProjectChef.io, including our application, website and blog (Our
        Services).
      </p>
      <br />
      <p className="font-semibold">DATA CONTROLLER FOR PERSONAL INFORMATION</p>
      <br />

      <p>
        Personal data of the User communicated when creating his/her account or
        when using the Service is collected and processed by ProjectChef.&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        The data collected includes the last name and first name of the person
        concerned, the name of the organization, the e-mail address, the date of
        the last connection to ProjectChef and the date the account was
        created.&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p className="font-semibold">DATA PROCESSING</p>
      <p>
        <br />
      </p>
      <p>
        ProjectChef processes the User&apos;s personal data in order to give
        him/her access to his/her account. The processing carried out therefore
        falls within the scope of Article 6 1) b) of Regulation 2016/679 of the
        European Parliament and of the Council of 27 April 2016 on data
        protection (the &quot;GDPR&quot;), pursuant to which processing is
        lawful if it is necessary for the performance of a contract to which the
        data subject is a party or User.&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        By accepting these Terms, You grants ProjectChef the right to send you
        information by email such as confirmation of registration. You grants
        ProjectChef also the right to contact you in order to discuss your user
        experience or the company&apos;s various offers.
      </p>
      <p>
        <br />
      </p>
      <p>
        &nbsp;In addition, You also agree to the processing of your Data for the
        purposes of sending newsletters. You have the right to unsubscribe from
        the newsletter anytime at the bottom of the newsletter page. &nbsp;
      </p>
      <p>
        <br />
      </p>
      <p className="font-semibold">USE OF COOKIES</p>
      <p>
        <br />
      </p>
      <p>
        ProjectChef may use &quot;cookies&quot; to enhance User experience and
        to analyze its audience.
      </p>
      <p>
        <br />
      </p>
      <p className="font-semibold">YOUR RIGHTS</p>
      <p>
        <br />
      </p>
      <p>
        As stipulated by GDPR, you have the right to access this data or request
        its deletion by contacting us on :{" "}
        <a
          className="text-primary-500"
          data-fr-linked="true"
          href="mailto:Support@projectchef.io"
        >
          Support@projectchef.io
        </a>
      </p>
      <br />
      <p className="font-semibold">DATA SECURITY AND PROTECTION</p>
      <br />
      <p>
        ProjectChef undertakes to implement the appropriate technical means to
        ensure the security of the Data.&nbsp;
      </p>
      <p>
        ProjectChef also undertakes to preserve the integrity and
        confidentiality of the Data contained in the Solutions and put in place
        technical and organisational measures to prevent any access to or
        fraudulent use of the Data and to prevent any loss, alteration or
        destruction of the Data.
      </p>
      <br />
      <p className="font-semibold">SHARING DATA</p>
      <br />
      <p>
        We do not sell, trade, or rent Users&apos; personal identification
        information to others. We may share generic aggregated demographic
        information not linked to any personal identification information
        regarding visitors and users with our business partners, trusted
        affiliates, and advertisers for the purposes outlined above.
      </p>
      <br />
      <p className="font-semibold">DATA BACKUP</p>
      <br />
      <p>
        Data is backed up daily. In the event of a major incident on a database
        server, the data will be restored to the version corresponding to the
        data backed up the day before the incident.
      </p>
      <p>
        ProjectChef reserves the right to delete and destroy your
        organization&rsquo;s identifiers and data managed as part of the
        solution in case you or your team have not logged on to our service for
        more than one year.
      </p>
      <p>
        <br />
      </p>
    </div>
  );
}
